import { createContext, useContext, useMemo, useState, type ReactNode } from 'react'

const ShortKeyContext = createContext<{
  subMarketkey: string
  setSubMarketkey: (v: string) => void
} | null>(null)

export function ShortKeyProvider({ children }: { children: ReactNode }) {
  const [subMarketkey, setSubMarketkey] = useState('')
  const value = useMemo(() => ({ subMarketkey, setSubMarketkey }), [subMarketkey])
  return <ShortKeyContext.Provider value={value}>{children}</ShortKeyContext.Provider>
}

export function useShortKey() {
  const ctx = useContext(ShortKeyContext)
  if (!ctx) throw new Error('useShortKey must be used inside ShortKeyProvider')
  return ctx
}
